import type { MaybeRefOrGetter } from 'vue';
import { computed, toValue } from 'vue';

export interface DisabledNoticeProps {
	disabled?: MaybeRefOrGetter<boolean | undefined>;
	disabledNotice?: MaybeRefOrGetter<string | undefined>;
}

export function useDisabledNotice(props: DisabledNoticeProps) {
	const showDisabledNotice = computed(() => toValue(props.disabled) && toValue(props.disabledNotice));
	return { showDisabledNotice };
}
